<template>
<v-container class="testpart pa-0">
  <v-card class="pt-3 card-r no-shadow shadow-1">
    <v-layout row wrap class="">
      <v-flex xs12 lg4>
        <v-card-title class="left f-15 text-primary font-weight-bold text-capitalize">
          Total : 20 questions Needed
        </v-card-title>
      </v-flex>
      <v-flex xs12 lg4>
        <v-text-field solo
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs12 lg4>
        <v-card-title class="right f-15 text-primary font-weight-bold text-capitalize align-center w-break">
          {{selectedQuestions.length}} selected - {{20-selectedQuestions.length}} Needed
        </v-card-title>
      </v-flex>
    </v-layout>

    <v-data-table
      :items="questionsList"
      :search="search"
      @update:pagination="updatePagination($event)"
      :pagination.sync="pagination"
      >

      <template v-slot:items="props">
        <tr class="w-100" :active="props.selected" @click="props.selected = !props.selected">
          <td><v-checkbox v-model=selectedQuestions :value="props.item.id" primary hide-details></v-checkbox></td>
          <td class="w-100 text-xs-right no-deraction w-break" v-html="props.item.situation"></td>
        </tr>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</v-container>
</template>
<script>
  /*eslint-disable */

  import api from '@/utils/backend-api'
  import axios from 'axios'
  export default {
    data () {
      return {
        search: '',
        pagination: {
          sortBy: 'name'
        },
        selected: [],
        questionsList: [
        ],
        pagination:{
          page: 0,
          // totalItems:50,
          rowsPerPage: 10,
        },
        question:{
          next_page_url:'',
          total:'',
        },
        selectedQuestions:[]
      }
    },
    watch:{
      selectedQuestions:function(){
        this.$emit("return-selected-questions",this.selectedQuestions)
      }
    },
    created:function(){
      this.getQuestions(20)
    },
    methods: {
      getQuestions(count){
          let self=this
          api.postData('driver/viewQuestions',{lang:'en',pagination:count})
          .then(res=>{
            self.questionsList=res.data.data
            self.question.next_page_url=res.data.next_page_url
            self.pagination.totalItems=res.data.total
          })
      },
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.desserts.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      updatePagination(event){
        let self=this
        if(this.questionsList.length-(event.page*this.pagination.rowsPerPage)<= this.pagination.rowsPerPage+1){
          let config={
            headers:{
              'Authorization': 'Bearer '+Store.state.token
            }
          }
          axios.post(self.question.next_page_url,'',config)
          .then(res=>{
            self.questionsList=self.questionsList.concat(res.data.data)
          })
        }

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/Manual.vue